<template>
<div class="test-content">
    <div class="symptoms-test-container check-symptoms-questions">
        <div class="symptoms-test-main">
            <h5>Molimo Vas recite nam još</h5>

            <a href="#" @click="onSkipSection" class="blueButton skip-btn">Preskoči ovu sekciju</a>

            <h6>Koji simptomi Vas muče najviše</h6>
            <div class="most-common-symptoms">
                <label v-for="symptom in symptoms" :key="symptom.id" class="radio-btn-container">{{symptom.name}}
                    <input type="radio" :checked="symptom.id === checkedSymptom.id"  name="radio">
                    <span @click="onCheckSymptom(symptom)" class="checkmark"></span>
                </label>
            </div>
            <div class="symptom-test-search">
                <label class="symptom-test-input-label" for="current-mediactions">Lekovi koje trenutno
                    koristite</label>
                <input v-model="drugSearchInput" @keyup="onDrugsInputKeyUp" type="text" class="symptom-test-input" id="current-mediactions"
                    placeholder="npr.Bensedin" />
                <div 
                    class="symptom-test-search-dropdown"
                    v-bind:class="{ show: showDrugSearchResults }">
                    <ul>
                        <li class="no-result" v-if="filteredDrugs.length === 0">Nema rezultata.</li>
                        <li 
                            v-for="(drug, index) in filteredDrugs" 
                            :key="drug.id"
                            @click="onChooseDrug(drug)"
                            v-bind:class="{ selected: index + 1 === selectedDropdownDrugItem }">
                            {{ drug.name }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="symptom-test-search">
                <label class="symptom-test-input-label" for="illness-hystory">Istorijat bolesti</label>
                <input v-model="conditionSearchInput" @keyup="onConditionsInputKeyUp" type="text" class="symptom-test-input" id="illness-hystory"
                    placeholder="npr.Artritis" />
                <div 
                    class="symptom-test-search-dropdown"
                    v-bind:class="{ show: showConditionSearchResults }">
                    <ul>
                        <li class="no-result" v-if="filteredConditions.length === 0">Nema rezultata.</li>
                        <li 
                            v-for="(condition, index) in filteredConditions" 
                            :key="condition.id"
                            @click="onChooseCondition(condition)"
                            v-bind:class="{ selected: index + 1 === selectedDropdownConditionItem }">
                            {{ condition.name }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        <test-data-box
            :activeStep="activeStep"
            :age="age" 
            :gender="gender" 
            :symptoms="symptoms" 
            :conditions="conditions" 
            :drugs="drugs"
            @editData="onEditData"
            @drugRemoved="onRemoveDrug"
            @conditionRemoved="onRemoveCondition">
        </test-data-box>
    </div>
</div>
</template>

<script>
import TestDataBox from './TestDataBox';
import fetchService from '../services/fetchService.js'

export default {
    name: 'ThirdStepQuestions',
    components: {
        TestDataBox,
    },

    props: ['activeStep', 'age', 'gender', 'symptoms', 'conditions', 'drugs'],

    data(){
        return {
            debounceTimeout: null,
            checkedSymptom: {},
            drugSearchInput: '',
            showDrugSearchResults: false,
            filteredDrugs: [],
            conditionSearchInput: '',
            showConditionSearchResults: false,
            filteredConditions: [],
            allConditions: [],
            selectedDropdownDrugItem: 0,
            numberOfDropdownDrugItems: 0,
            selectedDropdownConditionItem: 0,
            numberOfDropdownConditionItems: 0,
        }
    },

    methods: {
        onEditData(step) {
            this.$emit('editData', step);
        },
        onCheckSymptom(symptom) {
            this.checkedSymptom = symptom;
        },
        async onSearchDrugs(term) {
            clearTimeout(this.debounceTimeout);
            let self = this;
            this.debounceTimeout = setTimeout(async function() {
                if (term.length > 1) {
                    let searchedDrugs = await fetchService.searchDrugs(term);
                    self.filteredDrugs = searchedDrugs.slice(0,5);
                    self.showDrugSearchResults = true;
                    self.selectedDropdownDrugItem = 0;
                    self.numberOfDropdownDrugItems = self.filteredDrugs.length;
                } else {
                    self.showDrugSearchResults = false;
                }
            }, 500)
        },
        onChooseDrug(drug) {
            this.$emit('drugAdded', { ...drug });
            this.showDrugSearchResults = false;
            this.drugSearchInput = '';
        },

        onRemoveDrug(drug) {
            this.$emit('drugRemoved', {...drug});
        },

        onChooseCondition(condition) {
            this.$emit('conditionAdded', { ...condition });
            this.showConditionSearchResults = false;
            this.conditionSearchInput = '';
        },
        
        onRemoveCondition(condition) {
            this.$emit('conditionRemoved', {...condition});
        },

        onSkipSection() {
           this.$emit('sectionSkipped'); 
        },

        onDrugsInputKeyUp(event) {
            if (event.keyCode === 40) {
                this.selectedDropdownDrugItem =  this.selectedDropdownDrugItem === this.numberOfDropdownDrugItems ? 1 : this.selectedDropdownDrugItem + 1;
            }
            if (event.keyCode === 38) {
                this.selectedDropdownDrugItem =  this.selectedDropdownDrugItem === 1 ? this.numberOfDropdownDrugItems : this.selectedDropdownDrugItem - 1;
            }
            if (event.keyCode === 13) {
                if(this.selectedDropdownDrugItem > 0) {
                    this.onChooseDrug(this.filteredDrugs[this.selectedDropdownDrugItem - 1]);
                }
            }
        },

        onConditionsInputKeyUp(event) {
            if (event.keyCode === 40) {
                this.selectedDropdownConditionItem =  this.selectedDropdownConditionItem === this.numberOfDropdownConditionItems ? 1 : this.selectedDropdownConditionItem + 1;
            }
            if (event.keyCode === 38) {
                this.selectedDropdownConditionItem =  this.selectedDropdownConditionItem === 1 ? this.numberOfDropdownConditionItems : this.selectedDropdownConditionItem - 1;
            }
            if (event.keyCode === 13) {
                if(this.selectedDropdownConditionItem > 0) {
                    this.onChooseCondition(this.filteredConditions[this.selectedDropdownConditionItem - 1]);
                }
            }
        },
    },

    async created() {
        this.allConditions = await fetchService.fetchConditions();
    },


    watch: {
        drugSearchInput:  async function(val, oldVal) {
            if (val.length > 1) {
                this.onSearchDrugs(val);
            } else {
                this.showDrugSearchResults = false;
            }
        },
        conditionSearchInput: function(val, oldVal) {
            if (val.length > 1) {
                this.filteredConditions = this.allConditions.filter(function(condition) {
                    return condition.name.toLowerCase().includes(val.toLowerCase());
                }).slice(0,5);
                this.showConditionSearchResults = true;
                this.selectedDropdownConditionItem = 0;
                this.numberOfDropdownConditionItems = this.filteredConditions.length;
            } else {
                this.showConditionSearchResults = false;
            }
        }
    }
  
}
</script>

<style>
.symptom-test-search .symptom-test-search-dropdown ul li.no-result:hover {
    background-color: white;
    color: #6d6e70;
}
</style>